import type {FC} from 'react';
import {FilterButton} from '~/GalleryPB/FilterButton';
import {ResultsCount} from '~/GalleryPB/ResultsCount';

interface ResultsHeaderProps {
  showFilterButton?: boolean;
  onFilterButtonClick?: () => void;
  numTemplates?: number;
}

export const ResultsHeader: FC<ResultsHeaderProps> = ({
  showFilterButton,
  onFilterButtonClick,
  numTemplates,
}) => (
  <div className="gallery__results-header">
    {showFilterButton && <FilterButton onClick={onFilterButtonClick} />}
    {numTemplates !== undefined && <ResultsCount numTemplates={numTemplates} />}
  </div>
);
